import http from '@core/fetch'
export default {
  getContentApi: body =>
    http(`/p/wedding/index.php/Admin/APIOrderCommentAppeal/commentDetail`, {
      body
    }), //获取申诉内容
  submitAppealApi: body =>
    http.post('/p/wedding/index.php/Admin/APIOrderCommentAppeal/submitAppeal', {
      body
    }), //提交申诉

  //问答申诉
  getAppealInfo_questionApi: body =>
    http('/p/wedding/Admin/APIQaMerchantAppeal/appeal', { body }),
  submitAppeal_questionApi: body =>
    http.post('/p/wedding/Admin/APIQaMerchantAppeal/submit_appeal', { body })
}
